import axios from 'axios'
import { THIRDPARTY_GOOGLE_USER, THIRDPARTY_FACEBOOK_USER, LIVEDEMY_DEFAULT_USER } from '@/components/common/constants.js'
const state = {
  profileDetails: {},
  // coursesEnrolled: {},
  // coursesCOEnrolled: [],
  // LOsEnrolled: [],
  itemsEnrolled: [] // stores all LOs and COs purchased by user
}
const getters = {
  getUserJvID: (state) => accountDetails => {
    // var  objectCategory = ''
    for (let i = 0; i < accountDetails.length; i++) {
      if (accountDetails[i].jvId !== LIVEDEMY_DEFAULT_USER && accountDetails[i].jvId !== THIRDPARTY_FACEBOOK_USER && accountDetails[i].jvId !== THIRDPARTY_GOOGLE_USER) {
        return accountDetails[i].jvId
      }
    }
    return LIVEDEMY_DEFAULT_USER
  },
  // returns purchased date and expiry date of enrolled Object
  // required to display on in coursePage's bannerVideo component
  getItemPurchasedDates: (state, getters) => itemDetails => {
    // console.log('here', JSON.stringify(itemDetails))
    for (let i = 0; i < getters.getItemsEnrolledByType(itemDetails.type).length; i++) {
      // console.log(i)
      if (getters.getItemsEnrolledByType(itemDetails.type)[i].contentId === itemDetails.id) {
        let expiryDate = getters.getItemsEnrolledByType(itemDetails.type)[i].expiryDate.split('T')[0].split('-').reverse().join('/')
        let purchaseDate = getters.getItemsEnrolledByType(itemDetails.type)[i].purchasedDate.split('T')[0].split('-').reverse().join('/')
        return {
          purchaseDate, expiryDate
        }
      }
    }
  },
  // returns true if item subscription is not expired else false if expired
  // here we check if item is purchased by user then validity based on current date,expiry date
  // for CO & LO check  current date and expiry date
  getItemSubscriptionStatus: (state, getters) => itemDetails => {
    // var index
    var expiryDate
    // get expiry date and check if user had purchased item
    // console.log(getters.getItemsEnrolledByType(itemDetails.type))
    if (getters.getItemsEnrolledByType(itemDetails.type) !== undefined && getters.getItemsEnrolledByType(itemDetails.type) !== null && getters.getItemsEnrolledByType(itemDetails.type).length > 0) {
      // console.log('in')
      for (let i = 0; i < getters.getItemsEnrolledByType(itemDetails.type).length; i++) {
        if (itemDetails.id === getters.getItemsEnrolledByType(itemDetails.type)[i].contentId) {
          // index = i
          expiryDate = getters.getItemsEnrolledByType(itemDetails.type)[i].expiryDate
          break
        }
      }
      // if expiryDate is undefined then user had not purchased item
      if (expiryDate === undefined) {
        return false
      } else {
        // continue comparision with current date and expiryDate
        var currentDate = new Date()
        var expiryDateList = expiryDate.substring(0, expiryDate.indexOf('T')).split('-')
        var newDate = {
          'year': expiryDateList[0],
          'month': parseInt(expiryDateList[1]) - 1,
          'day': expiryDateList[2]
        }
        expiryDateList = []
        expiryDateList = expiryDate.substring(expiryDate.indexOf('T') + 1, expiryDate.indexOf('.')).split(':')
        newDate['hour'] = expiryDateList[0]
        newDate['min'] = expiryDateList[1]
        newDate['sec'] = expiryDateList[2]
        expiryDate = new Date(newDate['year'], newDate['month'], newDate['day'], newDate['hour'], newDate['min'], newDate['sec'])
        if (currentDate >= expiryDate) {
          return false
        } else {
          return true
          // if (this.$store.getters.getCourseEnrolled[index].watchedOn.length < this.$store.getters.getCourseEnrolled[index].allowedViewCount) {
          //   return true
          // } else {
          //   return false
          // }
          // if (itemDetails.type === 'LO') {
          //   // console.log('for lo')
          //   if (getters.getItemsEnrolledByType('LO')[index].watchedOn.length < getters.getItemsEnrolledByType('LO')[index].allowedViewCount) {
          //     // console.log('returning', getters.getItemsEnrolledByType('LO')[index].title)
          //     return true
          //   } else {
          //     return false
          //   }
          // } else {
          //   // console.log('for co')
          //   return true // for co
          // }
        }
      }
    }
  },
  // checks whether tag is allocated to user
  getTagAllocationStatus: (state, getters) => itemDetails => {
    // prepare profile tagList
    if (getters.getProfileDetails.tagList !== null && getters.getProfileDetails.tagList !== undefined) {
      var profileTagList = []
      for (let i = 0; i < getters.getProfileDetails.tagList.length; i++) {
        profileTagList.push(getters.getProfileDetails.tagList[i].tagName)
      }
      for (let i = 0; i < itemDetails.contentTagList.length; i++) {
        if (profileTagList.includes(itemDetails.contentTagList[i].tag)) {
          return true
        }
      }
    }
    return false
  },
  // returns items purchased by user based on itemType
  // itemType can be : ALL, LO, CO
  getItemsEnrolledByType: (state, getters) => itemType => {
    // if item Type is ALL send all LOs n COs
    if (itemType === 'ALL') {
      return state.itemsEnrolled
    } else { // sort base on itemType i.e LOs n COs
      let items = []
      for (let i = 0; i < state.itemsEnrolled.length; i++) {
        if (state.itemsEnrolled[i].courseType === itemType) {
          items.push(state.itemsEnrolled[i])
        }
      }
      return items
    }
  },
  // returns True if user had purchased item else False if not
  getItemPurchasedStatus: (state, getters) => itemId => {
    // console.log('---->', getters.getIsLoggedIn)
    if (getters.getIsLoggedIn) {
      var itemStatus = false
      for (let i = 0; i < state.itemsEnrolled.length; i++) {
        if (state.itemsEnrolled[i].contentId === itemId) {
          itemStatus = true
          break
        }
      }
      return itemStatus
    } else {
      return false
    }
  },
  getProfileDetails: state => { return state.profileDetails },
  // getCourseEnrolled: state => { return state.coursesEnrolled },
  getPurchaseStatus: (state, getters) => itemId => {
    var flag = false
    for (var i = 0; i < getters.getCourseEnrolled.length; i++) {
      if (getters.getCourseEnrolled[i].contentId === itemId) {
        flag = true
        break
      } else {
        flag = false
      }
    }
    return flag
  },
  // getCourseCOEnrolled: state => { return state.coursesCOEnrolled },
  // getLOsEnrolled: state => { return state.LOsEnrolled },
  getLastViewedDurationbyContentId: function (state, getters) {
    return function (contentId) {
      var matchedEnrolledObj = null
      // alert(getters.getLOsEnrolled.length)
      if (getters.getItemsEnrolledByType('LO').length !== 0) {
        getters.getItemsEnrolledByType('LO').forEach(element => {
          // alert(JSON.stringify(element))
          if (element.contentId === contentId && element.watchedOn.length !== 0) {
            matchedEnrolledObj = element
            // alert(JSON.stringify('null' + element.watchedOn))
            // var watchlenght = element.watchedOn.length
            // return element.watchedOn[watchlenght - 1].duration
          } else {
            // return 0
          }
        })
      }
      if (matchedEnrolledObj !== null && matchedEnrolledObj.watchedOn.length !== 0) {
        var watchlenght = matchedEnrolledObj.watchedOn.length
        // alert('watch time' + (matchedEnrolledObj.watchedOn[watchlenght - 1].duration / 60))
        return (matchedEnrolledObj.watchedOn[watchlenght - 1].duration / 60)
      } else {
        // console.log('return 0')
        return 0
      }
    }
  },
  /* getLastViewedDurationbyContentId: function (state, getters) {
    return function (contentId) {
      var matchedEnrolledObj = null
      // alert(getters.getLOsEnrolled.length)
      if (getters.getLOsEnrolled.length !== 0) {
        getters.getLOsEnrolled.forEach(element => {
          // alert(JSON.stringify(element))
          if (element.contentId === contentId && element.watchedOn.length !== 0) {
            matchedEnrolledObj = element
            // alert(JSON.stringify('null' + element.watchedOn))
            // var watchlenght = element.watchedOn.length
            // return element.watchedOn[watchlenght - 1].duration
          } else {
            // return 0
          }
        })
      }
      if (matchedEnrolledObj !== null && matchedEnrolledObj.watchedOn.length !== 0) {
        var watchlenght = matchedEnrolledObj.watchedOn.length
        // alert('watch time' + (matchedEnrolledObj.watchedOn[watchlenght - 1].duration / 60))
        return (matchedEnrolledObj.watchedOn[watchlenght - 1].duration / 60)
      } else {
        // console.log('return 0')
        return 0
      }
    }
  }, */
  getEnrolledLODataByContentIdProfileId: (state, getters) => {
    // var result = {}
    // console.log(JSON.stringify(getters.getItemsEnrolledByType('LO')))
    if (getters.getItemsEnrolledByType('LO').length !== null) {
      for (var i = 0; i < getters.getItemsEnrolledByType('LO').length; i++) {
        if (getters.getItemsEnrolledByType('LO')[i] !== null) {
          // console.log(JSON.stringify(getters.getItemsEnrolledByType('LO')[i]))
          // console.log(getters.getItemsEnrolledByType('LO')[i].contentId)
          // console.log(getters.getcurrentPlayingContent.contentId)
          if (getters.getItemsEnrolledByType('LO')[i].profileId === getters.getProfileDetails.profileId && getters.getItemsEnrolledByType('LO')[i].contentId === getters.getcurrentPlayingContent.contentId) {
            // console.log(JSON.stringify(getters.getItemsEnrolledByType('LO')[i].expiryDate))
            return getters.getItemsEnrolledByType('LO')[i]
            // console.log(JSON.stringify(result))
          }
        }
      }
    }
  },
  getExpiryDateForNonPurchaseLO: (getters) => detailsObj => {
    // console.log(JSON.stringify(detailsObj.LotagList))
    // console.log(JSON.stringify(detailsObj.userAssignedTagList))
    return ''
  }
}
const mutations = {
  // stores all LOs and COs purchased by user on login
  setItemsEnrolled (state, data) {
    state.itemsEnrolled = data
  },
  setProfileDetails (state, data) {
    state.profileDetails = data
  },
  setProfileID (state, id) {
    // console.log('setting profile Id')
    if (state.profileDetails === null) {
      state.profileDetails = {}
    }
    state.profileDetails.profileId = id
  },
  setProfileImg (state, imagePath) {
    if (state.profileDetails === null) {
      state.profileDetails = {}
    }
    state.profileDetails.profileImg = imagePath
  },
  // setCourseEnrolled (state, data) {
  //   state.coursesEnrolled = data
  // },
  // setLOEnrolled (state, data) {
  //   state.LOsEnrolled = data
  // },
  // setCourseCOEnrolled (state, data) {
  //   state.coursesCOEnrolled = data
  // },
  // clearCOEnrolledData (state) {
  //   state.coursesCOEnrolled = []
  //   state.coursesEnrolled = []
  // },
  // clearLOEnrolledData (state) {
  //   state.LOsEnrolled = []
  // },
  clearProfileDetails (state) {
    state.profileDetails = null
  },
  clearEnrolledItemsDetails (state) {
    state.itemsEnrolled = []
  },
  setLinkedAccountsDetailsInStore (state, data) {
    state.profileDetails.accountDetails = data
  }

}

const actions = {
  addLinkedAccountsDetailsInStore (context, data) {
    var accountDetails = context.getters.getProfileDetails.accountDetails
    // console.log('b4', JSON.stringify(accountDetails))
    accountDetails.push(data)
    // console.log('aF', JSON.stringify(accountDetails))
    context.commit('setLinkedAccountsDetailsInStore', accountDetails)
  },
  // resets the user display picture
  removeDiplayPictureFromStore (context) {
    return new Promise((resolve, reject) => {
      var profileObj = context.getters.getProfileDetails
      // console.log(JSON.stringify(profileObj))
      // alert(profileObj.profileImg)
      profileObj.profileImg = ''
      context.commit('setProfileDetails', profileObj)
      resolve(true)
    })
  },
  // returns skills of user
  getUserSkillsFromDB (context, data) {
    // alert(JSON.stringify(data))
    /* var itemIdList = []
    for (let i = 0; i < getters.getItemsEnrolledByType('CO').length; i++) {
      if (getters.getItemsEnrolledByType('CO')[i].allocationDetails.completionPercentage === 100) {
        itemIdList.push({'contentId': getters.getItemsEnrolledByType('CO')[i].contentId})
      }
    } */
    if (data.length !== 0) {
      return new Promise((resolve, reject) => {
        axios
          .post('r/getLoSkills', data).then(response => {
            // console.log(JSON.stringify(response.data))
            resolve(response.data)
          }).catch(err => {
            console.log('error in getting lo skills from db :', err)
            reject(err)
          })
      })
    }
  },
  // called for saving user profile changes
  saveProfileChanges (context, data) {
    return new Promise(function (resolve, reject) {
      axios
        .post('/r/updateBasicProfile', data)
        .then(function (response) {
          context.dispatch('fetchProfile', context.getters.getProfileDetails.profileId).then(function () {
            resolve()
          }).catch(function (err) {
            console.log('err profile fetched : ', err)
            reject(err)
          })
          // b.in_profileImage = ''
          resolve()
        })
        .catch(function (error) {
          console.log('error in  saving profile details : ', error)
          reject(error)
        })
    })
  },
  // called for replace file
  replaceFile (context, data) {
    return new Promise(function (resolve, reject) {
      // console.log(JSON.stringify(data))
      axios
        .post(data.url, data.formData, { headers: { 'Bussiness-Code': data.BussinessCode, 'Client-Code': data.ClientCode } })
        .then(Response => {
          // console.log('success', Response.status)
          resolve(Response)
        })
        .catch(error => {
          console.log('err in store file', error)
          reject(error)
        })
    })
  },
  // called for uploading file
  uploadFile (context, data) {
    return new Promise(function (resolve, reject) {
      // console.log(JSON.stringify(data))
      axios
        .post(data.url, data.formData, { headers: { 'Bussiness-Code': data.BussinessCode, 'Client-Code': data.ClientCode } })
        .then(Response => {
          // console.log('success', Response.status)
          resolve(Response)
        })
        .catch(error => {
          console.log('err in store file', error)
          reject(error)
        })
    })
  },
  // called for deleting file
  deleteFile (context, data) {
    return new Promise(function (resolve, reject) {
      axios
        .post(data.url, { url: data.filePath }, { headers: { 'Bussiness-Code': data.BussinessCode, 'Client-Code': data.ClientCode } })
        .then(Response => {
          resolve()
        })
        .catch(error => {
          console.log('error  in deleting file', error)
          reject(error)
        })
    })
  },
  fetchProfile (context, data) {
    // console.log('dataReceived' + data)
    return new Promise((resolve, reject) => {
      axios.post('/r/getUserProfile', {
        'profileId': data
      })
        .then(res => {
          // console.log('res=>' + JSON.stringify(res.data.items))
          // context.commit('setCartID', res.data.cartId)
          if (res.data.items !== null) {
            context.commit('setProfileDetails', res.data)
          }
          resolve()
        })
        .catch(err => {
          console.log('error viewing', err)
          reject(err)
        })
    })
  },
  /* fetchEnrolledCourses (context, data) {
    // console.log('dataReceived' + data)
    return new Promise((resolve, reject) => {
      axios.post('/r/viewCourseEnrolledData', {
        'profileId': data
      })
      .then(res => {
        if (res.data !== null || res.data.length !== 0) {
          context.commit('setCourseEnrolled', res.data)
        }
        var LOArray = []
        var COArray = []
        if (res.data.items !== null) {
          res.data.forEach(element => {
            if (element.courseType === 'CO') {
              COArray.push(element)
            } else if (element.courseType === 'LO') {
              LOArray.push(element)
            }
            //  this Arrays are used seperately for lo & co
            context.commit('setCourseCOEnrolled', COArray)
            context.commit('setLOEnrolled', LOArray)
          })
          resolve()
        }
      })
      .catch(err => {
        console.log('error viewing', err)
        reject(err)
      })
    })
  }, */
  fetchEnrolledItems (context, data) {
    // console.log('dataReceived' + data)
    return new Promise((resolve, reject) => {
      axios.post('/r/viewCourseEnrolledData', {
        'profileId': data
      })
      .then(res => {
        if (res.data !== null || res.data.length !== 0) {
          context.commit('setItemsEnrolled', res.data)
        }
        resolve()
      })
      .catch(err => {
        console.log('error viewing', err)
        reject(err)
      })
    })
  },
  updateProfileItemDuration (context, data) {
    return new Promise((resolve) => {
      context.commit('updateProfileItemDuration', data)
      resolve()
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/profile.js